<template>
  <div :class="['goal-last-goal-activity-message', small ? '-small' : '']">
    <div
      v-if="showIcon"
      class="_left"
    >
      <m-icon
        class="_icon"
        type="message"
        :color="$colors.grey.base"
        :size="small ? '12' : '13'"
      />
      <div class="_line" />
    </div>
    <div :class="['_right', wrap ? '' : '-nowrap']">
      <rich-text-prop
        :entity="entity"
        :prop="prop"
        :wrap="wrap"
        :default-font-size="small ? '1.2rem' : undefined"
      />
    </div>
  </div>
</template>

<script setup>
import RichTextProp from '@/components/list/RichTextProp.vue';
import useGoalActivity from '@/composables/goal-activity/goal-activity';
import { computed } from 'vue';
import {
  goalActivity as goalActivityConfig,
} from 'shared/api/query/configs.json';

const props = defineProps({
  goalActivity: {
    type: Object,
    default: null,
  },
  showIcon: {
    type: Boolean,
    default: false,
  },
  wrap: {
    type: Boolean,
    default: false,
  },
  small: {
    type: Boolean,
    default: false,
  },
});

const prop = { isDirect: true, property: { edgeName: goalActivityConfig.edges.message } };
const goalActivitySvc = useGoalActivity();
// FIXME: this is a hack to overcome shortcomings of nebula (normalization-step)
//  Currently, we can't have cycles in the schema that match data cycles. E.g., Goal -> GA -> Goal.
//  We can't tell nebula that an input must be normalized but the predicate shouldn't be denormalized.
//  We have been attempting to walk around the inner library 'normalizr', which doesn't support this.
const entity = computed(() => {
  if (props.goalActivity === null) {
    return null;
  }
  const entity = goalActivitySvc.selectSingle(props.goalActivity.uid);
  return entity === undefined ? props.goalActivity : entity;
});
</script>

<style
    scoped
    lang="scss"
    type="text/scss"
>
.goal-last-goal-activity-message {
  display: flex;
  gap: .5rem;
  align-items: flex-start;

  ._left {
    margin-top: .4rem;
    display: flex;
    flex-direction: column;
    gap: .4rem;
    height: fill-available;
    align-items: center;

    ._line {
      flex-grow: 1;
      width: 1px;
      background-color: map_get($grey, 'lighten-2');
      margin-bottom: .8rem;
    }
  }

  ._right {
    margin-top: -.4rem;

    &.-nowrap {
      margin-top: 0;
    }
  }

  &.-small {
    min-height: 2.1rem;

    ._left {
      margin-top: .2rem;
    }
  }
}
</style>
